const message = {
  testimonialsOfOurPatients:
    "Testimonials<br class='d-none d-lg-flex'> of our <span class='text-green'>patients</span>",
  condition: "Condition",
  communityHealth: "Community <span class='text-green'>health</span>",
  eventAndActivities: "Upcoming events<br> and <span class='text-green'> activities </span>",
  lastNews: "Last <span class='text-green'> news </span> ",
  keepReading: "Keep reading",
  whereToFindUs: "Where to  <span class='text-green'> find us </span> ",
  headquarters: "Headquarters",
  schedule: "Monday - Friday <br>7:00 to 16:00 <br>Saturday: 7:00 to 11:00",
  scheduleYourAppointment: "Schedule your appointment with a single click",
  scheduleAnAppointment: "Schedule an appointment",
};
export default message;
